import { httpTokenCommon } from "../helper/http-common";

export interface ItemControlReleaseCreateDto {
  itemId: string;
  quantityReleased: number;
  controlLogic: "None" | "Consumption" | "Customer";
  maxQtyPerCustomer?: number;
  authorizedCustomerIds?: string[];
  batchNumber?: string;   // optional: null/empty = applies to ALL batches
}

export interface ItemControlReleaseUpdateDto {
  id: string;
  itemId: string;
  quantityReleased: number;
  controlLogic: "None" | "Consumption" | "Customer";
  maxQtyPerCustomer?: number;
  authorizedCustomerIds?: string[];
  batchNumber?: string;
}

class ItemControlService {
  getAll() {
    return httpTokenCommon.get("itemcontrol", { silent: true });
  }

  search(params?: { keyword?: string; pageNumber?: number; pageSize?: number }) {
    return httpTokenCommon.get("itemcontrol/search", { params });
  }

  create(dto: ItemControlReleaseCreateDto) {
    return httpTokenCommon.post("itemcontrol", dto);
  }

  update(id: string, dto: ItemControlReleaseUpdateDto) {
    return httpTokenCommon.put(`itemcontrol/${id}`, dto);
  }

  remove(id: string) {
    return httpTokenCommon.delete(`itemcontrol/${id}`);
  }

  getSites() {
    return httpTokenCommon.get("itemcontrol/sites");
  }

  // Fetch batch/lot list for a product in WHM context.
  // Uses { silent: true } so the HTTP interceptor doesn't pop an error toast
  // when the endpoint returns 400 for non-customer users.
  getBatchesForItem(productCode: string) {
    return httpTokenCommon.get(
      `returns/batchhistory?productNumber=${encodeURIComponent(productCode)}`,
      { silent: true }
    );
  }
}

const itemControlService = new ItemControlService();
export default itemControlService;
